import React from "react";
import PropTypes from "prop-types";

import styles from "./IBOInfoCard.module.css";
import classNames from "classnames";

import Link from "shared/Link";

/**
 * View component.
 * Displays IBO information inside a card format.
 */
export function IBOInfoCard({ ibo, iboPage }) {
  return (
    <div className={styles.container}>
      <div className={styles.title}>Primary Info</div>

      <div className={styles.hr} />

      <div
        className={classNames(
          styles.content,
          !ibo.membershipStatus && styles.fourByTwo
        )}
      >
        <div className={styles.spacer}>
          <div className={styles.title}>IBO Name</div>
          <div className={styles.text}>{ibo.name}</div>
        </div>
        <div>
          <div className={styles.title}>IBO Number</div>
          {iboPage ? (
            <Link to={`/membership/lookup/ibo/${ibo.number}`}>
              <div className={classNames(styles.text, styles.link)}>
                {ibo.number}
              </div>
            </Link>
          ) : (
            <Link to={`/security/ibo/${ibo.number}`}>
              <div className={classNames(styles.text, styles.link)}>
                {ibo.number}
              </div>
            </Link>
          )}
        </div>
        <div>
          <div className={styles.title}>Email</div>
          <div className={styles.text}>{ibo.email}</div>
        </div>
        <div>
          <div className={styles.title}>Phone</div>
          <div className={styles.text}>{ibo.phoneNumber}</div>
        </div>
        <div>
          <div className={styles.title}>Username</div>
          <div className={styles.text}>{ibo.username}</div>
        </div>

        {ibo.membershipStatus && (
          <div>
            <div className={styles.title}>Membership Status</div>
            <div className={styles.text}>{ibo.membershipStatus}</div>
          </div>
        )}

        <div>
          <div className={styles.title}>Address</div>
          <div>
            {ibo.address} {ibo.city}, {ibo.state} {ibo.zip}
          </div>
        </div>
      </div>
    </div>
  );
}

IBOInfoCard.propTypes = {
  /**
   * Object with the IBO's details.
   */
  ibo: PropTypes.shape({
    name: PropTypes.string,
    number: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    username: PropTypes.string,
    birthdate: PropTypes.string,
    address: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
    membershipString: PropTypes.string,
  }),
};
